import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import CourseActionButton from './Hero/CourseActionButton';
import { useCourseContext } from '../_contexts/CourseContext';
import useCourseStatus from '../_hooks/useCourseStatus';
const ActionWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  flexShrink: 0
});
const StartNowButtonWrapper = styled('div')(({
  theme: {
    breakpoints,
    spacing
  }
}) => ({
  marginTop: spacing(1),
  [breakpoints.up('sm')]: {
    marginTop: spacing(2)
  }
}));
function FooterAction(t0) {
  const $ = _c(7);
  const {
    userId
  } = t0;
  const {
    course
  } = useCourseContext();
  const {
    isFinished,
    hasAlreadyFollowed,
    notStarted,
    isFollowing
  } = useCourseStatus(course);
  if (isFinished) {
    return null;
  }
  if (hasAlreadyFollowed && userId) {
    let t1;
    if ($[0] !== userId) {
      t1 = <ActionWrapper data-testid="course-footer"><CourseActionButton action="follow" userId={userId} /></ActionWrapper>;
      $[0] = userId;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (notStarted) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Typography variant="subheading" component="span" style={{
        textAlign: "center"
      }}>{translate("course.bottom_banner.incentive")}</Typography>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== userId) {
      t2 = <ActionWrapper data-testid="course-footer">{t1}<StartNowButtonWrapper><CourseActionButton action="start" userId={userId} /></StartNowButtonWrapper></ActionWrapper>;
      $[3] = userId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (isFollowing) {
    let t1;
    if ($[5] !== userId) {
      t1 = <ActionWrapper data-testid="course-footer"><CourseActionButton action="continue" userId={userId} /></ActionWrapper>;
      $[5] = userId;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  return null;
}
export default FooterAction;